import React from 'react';
import styled from 'styled-components';

// Styled Component
const StyledContainer = styled.div`
  width: 100%;
  max-width: ${(props) => props.maxWidth || '1200px'};
  margin: 0 auto; /* Centra il contenitore */
  box-sizing: border-box; /* Il padding non aumenta la larghezza */
  overflow-wrap: break-word; /* Per browser moderni */
  word-wrap: break-word; /* Spezza il testo lungo */
  padding: ${(props) => props.padding || '0'};

    @media (max-width: 768px) {
  }
`;

// Component
const Wrapper = ({ children, maxWidth, padding }) => {
  return (
    <StyledContainer maxWidth={maxWidth} padding={padding}>
      {children}
    </StyledContainer>
  );
};

export default Wrapper;
